import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ReactComponent as MenuIconWhite } from '../../../assets/icons/MenuDots.svg';
import { ReactComponent as MenuIconBlack } from '../../../assets/icons/MenuDotsB.svg';
import { ReactComponent as ListIcon } from '../../../assets/icons/list.svg';
import {
  Resource,
  getResourceBodySystemLabel,
  getResourceMriConditionLabel,
} from '../../../api/resourceCenter';
import './ResourceCenterTable.scss';

type Props = {
  resourceData: Resource;
  onViewResource: (resource: Resource) => void;
  onEditResource: (resource: Resource) => void;
  onDeleteResource: (resourceId: number) => void;
};

const ResourceCenterTableRow: React.FC<Props> = ({ resourceData, onViewResource, onEditResource, onDeleteResource }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const onOptionClick = (action: string) => {
    if (action === 'view') {
      onViewResource(resourceData);
    } else if (action === 'edit') {
      onEditResource(resourceData);
    } else if (action === 'delete') {
      onDeleteResource(parseInt(resourceData.id));
    }
    setIsMenuOpen(false);
  };

  const actionMenuStyles = {
    backgroundColor: isMenuOpen ? '#238698' : 'transparent',
  };

  const onMenuIconClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className='table-row'>
      <div className='table-cell resource-name'>
        {resourceData.name ? resourceData.name : '-'}
      </div>
      <div className='table-cell biomarkers'>
        {resourceData.biomarkers && resourceData.biomarkers.length > 0 
          ? resourceData.biomarkers.map(bm => bm.name).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell conditions'>
        {resourceData.conditions && resourceData.conditions.length > 0 
          ? resourceData.conditions.map(cond => cond.name).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell mri-conditions'>
        {resourceData.mri_conditions && resourceData.mri_conditions.length > 0
          ? resourceData.mri_conditions.map(getResourceMriConditionLabel).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell body-systems'>
        {resourceData.body_systems && resourceData.body_systems.length > 0
          ? resourceData.body_systems.map(getResourceBodySystemLabel).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell actions'>
        <OutsideClickHandler onOutsideClick={() => setIsMenuOpen(false)}>
          <div className='action-menu-container'>
            <div className='menu-btn' style={actionMenuStyles}>
              {isMenuOpen ? (
                <MenuIconWhite onClick={(e) => onMenuIconClick(e)} />
              ) : (
                <MenuIconBlack onClick={(e) => onMenuIconClick(e)} />
              )}
            </div>
            {isMenuOpen && (
              <div className='action-menu'>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOptionClick('view');
                  }}
                  className='option'
                >
                   <ListIcon />
                  View/Edit
                </div>
              </div>
            )}
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default ResourceCenterTableRow;
